import notificationMp3 from '../assets/notification.mp3';

let audio: HTMLAudioElement | null = null;
let canPlay = false;
let unlockListenersAttached = false;

function getAudio(): HTMLAudioElement {
  if (!audio) {
    audio = new Audio(notificationMp3);
    audio.preload = 'auto';
  }

  return audio;
}

function removeUnlockListeners(unlock: () => void) {
  window.removeEventListener('pointerdown', unlock);
  window.removeEventListener('keydown', unlock);
}

export function initNotificationSound() {
  if (typeof window === 'undefined' || unlockListenersAttached) return;
  unlockListenersAttached = true;

  const unlock = () => {
    const element = getAudio();
    void element
      .play()
      .then(() => {
        element.pause();
        element.currentTime = 0;
        canPlay = true;
        removeUnlockListeners(unlock);
      })
      .catch(() => {
        // Autoplay still blocked; keep listeners for the next gesture.
      });
  };

  window.addEventListener('pointerdown', unlock);
  window.addEventListener('keydown', unlock);
}

export function playNotificationSound(muted: boolean) {
  if (muted || !canPlay) return;

  const element = getAudio();
  element.currentTime = 0;
  void element.play().catch(() => {
    canPlay = false;
    unlockListenersAttached = false;
    initNotificationSound();
  });
}
